﻿module Client.ContractPage.ChangeOrders.Items

open FSharpPlus
open Client
open Elmish
open Fable.FontAwesome
open Fable.React
open Feliz
open Feliz.UseElmish
open Shared
open PortalLibs.Shared
open PortalLibs.Client.Util
open Feliz.Bulma
open Shared.Models
open Client.ContractPage.ChangeOrders.Rows

let ItemRow =
  React.memo<{| Item: ChangeOrderItem; ChildrenLines: ItemId -> ReactElement
                ChangeOrderType: ChangeOrderType
                Expanded: bool; Expand: int64 -> unit; Collapse: int64 -> unit |}>(
    name = "ItemRow",
    areEqual = Helpers.equalsButFunctions,
    withKey = (fun props -> props.Item.Id.ToString()),
    render = fun props ->
      
    let expanded = props.Expanded
    let toggle = if expanded then props.Collapse else props.Expand
    let item = props.Item
    let changeOrderType = props.ChangeOrderType
    
    React.fragment [
      Html.tr [
        prop.onClick (fun _ -> toggle item.Id)
        if expanded then prop.style[selectedRow]
        prop.children [
          Html.td [
            prop.style [ style.textAlign.right ]
            prop.text item.ACOItem
          ]
          if changeOrderType = ChangeOrderType.Pending then
            Html.td [
              prop.style [ style.textAlign.left ]
              prop.text (item.PCOType |> Option.emptyStrIfNone)
            ]
          Html.td [
            Html.a [
              Html.div [
                prop.style[ style.display.flex; style.justifyContent.spaceBetween ]
                prop.children [
                  Html.strong[ item.Description |> emptyStrTagIfNone ]
                  Bulma.icon [
                    prop.style [ style.color "#b5b5b5" ]
                    prop.children [
                      Fa.i [ if expanded then Fa.Solid.ChevronUp else Fa.Solid.ChevronDown ] []
                    ]
                  ]
                ]
              ]
            ]
          ]
          Html.td [
            prop.style [ style.textAlign.right ]
            prop.text (item.UM |> Option.emptyStrIfNone)
          ]
          Html.td [
            prop.style [ style.textAlign.right ]
            prop.text (item.Units |> DisplayNumber.AsNumber.stdOrEmptyString)
          ]
          Html.td [
            prop.style [ style.textAlign.right ]
            prop.text (item.UnitPrice |> DisplayNumber.AsCurrency.stdOrEmptyString)
          ]
          Html.td [
            prop.style [ style.textAlign.right ]
            prop.text (item.Amount |> DisplayNumber.AsNumber.std)
          ]
        ]
      ]
      if expanded then
        Html.tr [
          Html.td [
            prop.colSpan (if changeOrderType = ChangeOrderType.Pending then 7 else 6)
            prop.className "change-orders-row-expanded"
            prop.children [props.ChildrenLines item.Id]
          ]
        ]
    ]
  )
  
let ItemsTable =
   React.memo<{| Items: Map<HeaderId, ChangeOrderItem list>; ChildrenLines: ItemId -> ReactElement
                 Header: ChangeOrderHeader |}>(
      name = "ItemsTable",
      render = fun props ->
      
      let items = props.Items |> Map.tryFind props.Header.Id
      let changeOrderType = props.Header.Type
      let state, dispatch = React.useElmish(init, update, [| box items |])
      let isPending = changeOrderType = ChangeOrderType.Pending
      match items with
      | None -> Html.text "Loading items..."
      | Some items -> 
        Bulma.table [
          prop.style [ style.alignSelf.flexEnd; Styles.stickyTableBorder ]
          table.isFullWidth
          table.isHoverable
          prop.children [
            Html.thead [
              Html.tr [
                prop.style (Styles.sticky(40, 1))
                prop.children [
                  let th styles (pct: int) (txt: string) =
                    Html.th [
                      prop.style [
                        yield! styles
                        style.verticalAlign.bottom
                        style.width(length.percent pct)
                        yield! Styles.bottomBorderWithColor(2, "#363636")
                      ]
                      prop.text txt
                    ]
                  th [style.textAlign.right] 5 ((if isPending then "PCO" else "ACO") + " Item")
                  if isPending then th [style.textAlign.left] 5 "PCO Type"
                  th [] 65 "Description"
                  
                  th [style.textAlign.right] 5 "UM"
                  th [style.textAlign.right] 5 "Units"
                  th [style.textAlign.right] 5 "Unit Price"
                  th [style.textAlign.right] 10 "Amount"
                ]
              ]
            ]
            Html.tbody [
              match items with
              | [] -> Html.tr [
                Html.td [
                  prop.colSpan (if changeOrderType = ChangeOrderType.Pending then 7 else 6)
                  prop.style [ style.textAlign.center; style.padding(length.px 30, 0)]
                  prop.text "No Change Order Items"
                ]]
              | items ->
                yield! items |>> fun item ->
                  ItemRow {| Item = item; Collapse = (Collapse >> dispatch)
                             Expand = (Expand >> dispatch); Expanded = state.Expanded |> List.contains item.Id
                             ChangeOrderType = changeOrderType
                             ChildrenLines = props.ChildrenLines |}
            ]
          ]
        ]
  )